/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Still_Elk_GrazeInputs */

const en_warm_still_elk_graze = /** @type {(inputs: Warm_Still_Elk_GrazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Define the data collection rounds that feed into this report.`)
};

const de_warm_still_elk_graze = /** @type {(inputs: Warm_Still_Elk_GrazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definieren Sie die Erhebungsrunden, die in diesen Bericht einfließen.`)
};

/**
* | output |
* | --- |
* | "Define the data collection rounds that feed into this report." |
*
* @param {Warm_Still_Elk_GrazeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_still_elk_graze = /** @type {((inputs?: Warm_Still_Elk_GrazeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Still_Elk_GrazeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_still_elk_graze(inputs)
	return de_warm_still_elk_graze(inputs)
});